import React, { FC } from "react";
import { Input, Form } from "antd";
import { BaseInputProps, BaseViewInput, getFormItemLabel } from "./BaseInput";
import { FormConsumer } from "./FormWrapper";

/**
 * @constant RenderField - Ant Design `Input` component for redux-form.
 */

const RenderField: FC<BaseInputProps> = ({
  label,
  labelSubtitle,
  meta,
  input,
  disabled,
  help,
  required,
  defaultValue,
  id,
  placeholder,
  allowClear,
  showNA,
}) => {
  return (
    <FormConsumer>
      {(value) => {
        if (!value.isEditMode) {
          return <BaseViewInput label={label} value={input?.value} showNA={showNA} />;
        }
        const labelString =
          (label || input.name) instanceof String ? String(label || input.name) : input.name;
        return (
          <Form.Item
            name={input.name}
            required={required}
            label={getFormItemLabel(label, required, labelSubtitle)}
            validateStatus={
              meta.touched ? (meta.error && "error") || (meta.warning && "warning") : ""
            }
            help={
              meta.touched &&
              ((meta.error && <span>{meta.error}</span>) ||
                (meta.warning && <span>{meta.warning}</span>))
            }
          >
            <>
              <Input
                data-testid={input.name}
                disabled={disabled}
                defaultValue={defaultValue}
                id={id}
                aria-label={labelString}
                placeholder={placeholder}
                allowClear={allowClear}
                {...input}
              />
              {help && <div className={`form-item-help ${input.name}-form-help`}>{help}</div>}
            </>
          </Form.Item>
        );
      }}
    </FormConsumer>
  );
};

export default RenderField;
